var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": _vm.synced ? 720 : 320,
      "persistent": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', _vm._b({}, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-title', [_vm._v(" MES 데이터 싱크 "), _c('v-spacer'), _c('v-icon', _vm._b({
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, 'v-icon', {
    loading: _vm.loading
  }, false), [_vm._v("mdi-close")])], 1), !_vm.synced ? [_c('v-card-text', {
    staticClass: "card-text-area"
  }, [_c('p', [_vm._v("MES 데이터와 싱크를 진행합니다.")]), _c('p', [_vm._v("MES와의 연결 상태에 따라 진행되지 않을 수 있습니다.")]), _c('p', [_vm._v("한 번 싱크된 데이터는 삭제되지 않으며, 신규 등록되는 데이터의 수에 따라 최소 수 초에서 수 분 이상의 시간이 소요됩니다.")])]), _c('v-card-actions', [_c('v-btn', _vm._b({
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.sync
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("진행하기")])], 1)] : [_c('v-card-text', {
    staticClass: "card-text-area"
  }, [_c('p', [_vm._v("MES 데이터 총 " + _vm._s(_vm.summary.totalCount) + " 건 중 " + _vm._s(_vm.summary.createdCount) + " 건을 생성하였습니다.")]), _vm.materials.length ? [_c('p', [_vm._v("새로 생성된 데이터는 아래 내역을 확인해주세요")])] : _vm._e()], 2), _vm.materials.length ? [_c('v-divider'), _c('v-data-table', _vm._b({}, 'v-data-table', {
    headers: _vm.headers,
    items: _vm.items
  }, false))] : _vm._e()]], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }